import { Section } from '@/components/shared';
import { ROUTE_PATHS } from '@/constants';
import { useAppDispatch, useAppSelector, useAuth } from '@/hooks';
import { pathJoin, scrollToTop } from '@/utils';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AuctionHouseForm } from '../components';
import { updateAuctionHouse } from '../store';
import type { IAuctionHouseInfo } from '../types';

export const AuctionHouseInfoStep: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { authUser } = useAuth();
  const defaultValues = useAppSelector((state) => state.quote.auctionHouse);

  scrollToTop();

  const handleSubmit = (data: IAuctionHouseInfo): void => {
    dispatch(updateAuctionHouse(data));
    const path = pathJoin([`/${ROUTE_PATHS.quote}`, ROUTE_PATHS.quoteShippingInfo]);
    navigate(path);
  };

  const handleBack = (): void => {
    const path = pathJoin([`/${ROUTE_PATHS.quote}`, ROUTE_PATHS.quoteUserInfo]);
    navigate(path);
  };

  return (
    <Section
      containerProps={{ py: 0 }}
      headingProps={{ mt: 0 }}
      id="auction-house-info"
      title={t('WIZARD.AUCTION_HOUSE.STEP_TITLE')}
    >
      <Flex
        alignItems={{ base: 'center', md: 'flex-start' }}
        direction={{ base: 'column', md: 'row' }}
        gap={8}
        justifyContent="center"
        w="full"
      >
        <Box textAlign={{ base: 'center', md: 'left' }}>
          <Heading fontSize={{ base: 'h2.base', md: 'h2.md' }} fontWeight="normal" pb={2}>
            {t('WIZARD.AUCTION_HOUSE.TITLE')}
          </Heading>
          <Text fontSize="large" mb={8}>
            <Trans i18nKey="WIZARD.AUCTION_HOUSE.CONTENT_ONE" />
          </Text>
          <Text fontSize="large">
            <Trans i18nKey="WIZARD.AUCTION_HOUSE.CONTENT_TWO" />
          </Text>
        </Box>
        <Flex direction="column" minWidth={{ base: 'full', md: 350, xl: 450 }}>
          <AuctionHouseForm
            defaultValues={defaultValues}
            isBackVisible={authUser?.isValid()}
            onBack={handleBack}
            onSubmit={handleSubmit}
          />
        </Flex>
      </Flex>
    </Section>
  );
};
